<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Borrar Documento?</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="4" md="2">
                                    Nivel: {{ nivel }}
                                </v-col>
                                <v-col cols="6" sm="8" md="4">
                                    Documento: {{ doc }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Código: {{ cod }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    Edición: {{ ed }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Revisión: {{ rev }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Fecha Revisión: {{ fecha }}
                                </v-col>
                                <!-- </v-row>
                        <v-row dense> -->
                                <v-col cols="6" sm="6" md="3">
                                    Originado en: {{ origen }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    Responsable: {{ resp }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    Cod. Clasificación: {{ clas }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Tiempo (años): {{ tiempo }}
                                </v-col>
                                <!-- </v-row>
                        <v-row dense> -->
                                <v-col cols="12" sm="12" md="8">
                                    Observaciones: {{ obs }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Borrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    props: ["visible", "cod"],
    data: (vm) => ({
        usuario: "",
        valid: false,
        deshabilitar: false,
        lazy: false,
        doc: "",
        nivel: "",
        ed: "",
        rev: "",
        fecha: "",
        clas: "",
        resp: "",
        origen: "",
        tiempo: "",
        obs: "",

    }),

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardocumento();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {

            this.nivel = "";
            this.resp = "";
            this.doc = "";
            this.ed = "";
            this.rev = "";
            this.clas = "";
            this.tiempo = "";
            this.fecha = "";
            this.obs = "";
            this.origen = "";
            this.$router.push({ name: "MainSgi" });
        },

        cargardocumento() {
            let self = this;
            axios
                .get("/Sgi/Cargardocumento?", {
                    params: {
                        cod: self.cod,
                    },
                })
                .then((response) => {
                    self.fecha = response.data.fecha;
                    self.nivel = response.data.nivel;
                    self.doc = response.data.doc;
                    self.ed = response.data.ed;
                    self.rev = response.data.rev;
                    self.clas = response.data.clas;
                    self.origen = response.data.origen;
                    self.resp = response.data.resp;
                    self.tiempo = response.data.tiempo;
                    self.obs = response.data.obs;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Borrar Documento",
                text: "¿Desea borrar el documento del EI043?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;

                    let self = this;
                    console.log("cod", self.cod)
                    axios
                        .get("/SGI/BorrarDocumento", {
                            params: {
                                cod: self.cod,
                            },
                        })
                        .then((response) => {

                            self.showAlert({
                                icon: "success",
                                title: "Documento borrado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
